export default __webpack_public_path__ + "static/media/group-630@2x.97f57ee5.png";